import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/VDriveLogo-01.png"

function Navbar() {
  const [toggleMenu, setToggleMenu] = useState(false);
  const sideMenuRef = useRef(null);
  const navigate = useNavigate()
  const [selectedMenu, setSelectedMenu] = useState("")

  const Menus = [
    {
      label: "Home",
      path: "/"
    },
    {
      label: "Pricing",
      path: "/pricing"
    },
    {
      label: "Services",
      path: "/services"
    },
    {
      label: "Contact Us",
      path: "/contact_us"
    },
    {
      label: "Terms & Conditions",
      path: "/term_and_condition"
    },
  ]

  useEffect(() => {
    if (window?.location?.href?.includes("pricing")) {
      setSelectedMenu("Pricing")
    }
    else if (window?.location?.href?.includes("services")) {
      setSelectedMenu("Services")
    }
    else if (window?.location?.href?.includes("contact_us")) {
      setSelectedMenu("Contact Us")
    }
    else if (window?.location?.href?.includes("term_and_condition")) {
      setSelectedMenu("Terms & Conditions")
    }
    else {
      setSelectedMenu("Home")
    }
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sideMenuRef.current && !sideMenuRef.current.contains(event.target)) {
        setToggleMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <nav className="relative px-4 py-4 flex justify-between items-center bg-white">
        <a onClick={() => navigate("/")} className=" ms-10 cursor-pointer" >
          <img style={{ scale: "1.6" }} width={120} height={100} src={logo} />
        </a>
        <div className="lg:hidden">
          <button
            onClick={() => {
              setToggleMenu(true);
            }}
            className="navbar-burger flex items-center text-blue-600 p-3"
          >
            <svg
              className="block h-4 w-4 fill-current"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Mobile menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
            </svg>
          </button>
        </div>
        <ul className="hidden absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 lg:flex lg:mx-auto lg:flex lg:items-center lg:w-auto lg:space-x-6">
          {Menus?.map((menu, index) => {
            return (
              <>
                <li
                  onClick={() => {
                    navigate(menu?.path)
                    setSelectedMenu(menu?.label)

                  }}
                >
                  <a className={`text-sm cursor-pointer ${selectedMenu == menu?.label ? "text-blue-600 font-bold" : "text-gray-400"} hover:text-gray-500`}>
                    {menu?.label}
                  </a>
                </li>
                {index != Menus?.length - 1 &&
                  <li
                    className="text-gray-300">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="currentColor"
                      className="w-4 h-4 current-fill"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 5v0m0 7v0m0 7v0m0-13a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                      />
                    </svg>
                  </li>}
              </>
            )
          })}
        </ul>
        <a
          href="https://api.whatsapp.com/send?phone=971508460229"
          className="hidden lg:inline-block lg:ml-auto lg:mr-3 py-2 px-6 bg-gray-50 hover:bg-gray-100 text-sm text-gray-900 font-bold  rounded-xl transition duration-200"
        >
          Book Now
        </a>
      </nav>
      <div
        className={`navbar-menu relative z-50 ${toggleMenu ? "" : "hidden"}`}
      >
        <div className="navbar-backdrop fixed inset-0 bg-gray-800 opacity-25"></div>
        <nav
          ref={sideMenuRef}
          className="fixed top-0 left-0 bottom-0 flex flex-col w-5/6 max-w-sm py-6 px-6 bg-white border-r overflow-y-auto"
        >
          <div className="flex items-center mb-8">
            <a onClick={() => navigate("/")} className="mr-auto text-3xl font-bold leading-none cursor-pointer" >
              <img width={120} height={100} src={logo} />
            </a>
            <button
              onClick={() => setToggleMenu(false)}
              className="navbar-close"
            >
              <svg
                className="h-6 w-6 text-gray-400 cursor-pointer hover:text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
          <div>
            <ul>
              {Menus?.map((menu, index) => {
                return (
                  <>
                    <li
                      onClick={() => {
                        navigate(menu?.path)
                        setSelectedMenu(menu?.label)
                      }}
                    >
                      <a className={`block p-4 text-sm font-semibold text-gray-400 hover:bg-blue-50 hover:text-blue-600 rounded ${selectedMenu == menu?.label ? "text-blue-600 font-bold" : "text-gray-400"}`}>
                        {menu?.label}
                      </a>
                    </li>
                  </>
                )
              })}
            </ul>
          </div>
          <div className="mt-auto">
            <div className="pt-6">
              <a
                href="https://api.whatsapp.com/send?phone=971508460229"
                className="block px-4 py-3 mb-3 leading-loose text-xs text-center font-semibold bg-gray-50 hover:bg-gray-100 rounded-xl"
              >
                Book Now
              </a>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Navbar;
